export default "__VITE_ASSET__DnKv9xNG__"